import styled from 'styled-components'
import Button from 'components/Button'
import { Tooltip, OverlayTrigger } from 'react-bootstrap'
import CommentForm from '../CallControls/CommentForm'
import ThumbsButton from '../CallControls/ThumbsButton'

const Wrapper = styled.div`
  position: relative;
  display: inline-block;
  margin-right: 20px;
`

const Container = styled.div`
  white-space: nowrap;
  position: absolute;
  right: 0;
  border-radius: 5px;
  z-index: 700;
  top: -36px;
  &.expanded {
    box-shadow: 10px 10px 64px 0px rgba(0, 0, 0, 0.15);
    border: 1px solid var(--light-gray);
    width: 350px;
    background: var(--white);
    left: -37vh;
    top: 3vh;
  }

  @media only screen and (max-width: 768px) {
    display: none;
  }
`

const Title = styled.div`
  font-size: 14px;
  float: left;
  line-height: 33px;
`
const Content = styled.div`
  padding: 15px;
`

const Buttons = styled.div`
  text-align: right;
  float: right;
`

const StyledButton = styled(ThumbsButton)`
  margin-left: 0;
  .expanded & {
    margin-left: 5px;
  }
`

const SubmitButton = styled(Button)`
  background: var(--main-color);
  color: var(--white);
  border-color: var(--main-color);
  float: right;
  margin-left: 28px;

  &:hover {
    color: var(--white);
  }
`
const FeedbackButton = styled(Button)`
  background-color: transparent;
  padding: 7px 20px;
  line-height: 1.5;

  @media only screen and (max-width: 768px) {
    font-size: 16px;
  }
`

const PanelButtons = ({
  handleClick,
  feedbackEnabled,
  handleChange,
  showForm,
  resolved,
  handleSubmit,
  contentType,
  handleBlur
}) => {
  const tooltip = <Tooltip id="feedback-tooltip">Article Helpful?</Tooltip>
  return (
    <Wrapper>
      <Container
        onBlur={handleBlur}
        tabIndex="0"
        className={showForm ? 'expanded' : ''}
      >
        <Content className="clearfix">
          <Title>
            {showForm && contentType !== 'general-feedback' && (
              <> Article Helpful?</>
            )}
            {showForm && contentType === 'general-feedback' && (
              <> Leave feedback</>
            )}
            {!feedbackEnabled && <>Thank you for the feedback</>}
          </Title>

          <Buttons>
            {feedbackEnabled && contentType !== 'general-feedback' && (
              <OverlayTrigger
                placement="top"
                overlay={tooltip}
                rootClose
                trigger={showForm ? [] : ['hover']}
              >
                <span>
                  <StyledButton
                    active={resolved === true}
                    direction="up"
                    handleClick={handleClick.bind(this, true)}
                  />
                  <StyledButton
                    active={resolved === false}
                    direction="down"
                    handleClick={handleClick.bind(this, false)}
                  />
                </span>
              </OverlayTrigger>
            )}

            {feedbackEnabled &&
              contentType === 'general-feedback' &&
              !showForm && (
                <FeedbackButton
                onClick={handleClick.bind(this, true)}
              >
                  Feedback
                </FeedbackButton>
              )}

            {showForm && (
              <SubmitButton onClick={handleSubmit}>Submit</SubmitButton>
            )}
          </Buttons>
        </Content>

        {showForm && <CommentForm handleChange={handleChange} />}
      </Container>
    </Wrapper>
  )
}

export default PanelButtons
